import settings from './modules/settings/Settings';
import theme from "./modules/theme/Theme";

export default{
    modules: {
        theme,
        settings,
    }

}
